import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'stringBuilder', standalone: true })
@Injectable({providedIn: 'root'})
export class StringBuilderPipe implements PipeTransform {
	
	transform(input, args1?, args2?, args3?) {
		if (input && args1) {
			input = input.replace('%s', args1);
		}
		if (input && args2) {
			input = input.replace('%s', args2);
		}
		if (input && args3) {
			input = input.replace('%s', args3);
		}
		return input;
	}
	
}